<template>
  <transition appear name="v--mask">
    <footer v-once class="blog__footer">
      <b-container>
        <div class="clearfix">&nbsp;</div>
        <b-row>
          <b-col class="footer__logo" lg="6" sm="12">
            <a class="signature" href="https://haidangtravel.com" target="_blank">
              <img src="../assets/Logo.png"/>
            </a>
          </b-col>
          <b-col v-if="!reading || $device.phone" class="footer__address text-center" lg="6" sm="12">
            <div class="info-list text-left">
              <div class="mb-2">
                <font-awesome-icon icon="map-marker"/>
                <span>367 Tân Sơn, Phường 15, Quận Tân Bình, Hồ Chí Minh</span></div>
              <div class="mb-2">
                <font-awesome-icon icon="phone"/>
                <span>19002011 - 0948991080</span></div>
              <div class="mb-2">
                <font-awesome-icon icon="mail-bulk"/>
                <a class="link" href="mailto:info@haidangtravel.com"><span>info@haidangtravel.com</span></a>
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="clearfix">&nbsp;</div>
        <b-row v-if="!reading || $device.phone">
          <b-col v-for="dp in destinationpoints" lg="3" sm="12" :key="dp.slug">
            <a class="link" :href="'https://haidangtravel.com/diem-den/'+dp.slug">
              Tour {{ dp.title }}
            </a>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </transition>
</template>
<script>
  export default {
    name: 'blog-footer',
    props: {
      destinationpoints: {
        type: Array,
        default: () => []
      },
      filters: {
        type: Object,
        default: () => {}
      }
    },
  // asyncComputed: {
  //   async destinationpoints() {
  //     let url = `http://haidangtravel.com/api/destinationpoint`;
  //     const res = axios.post(url).then(function(response) {
  //       // this.destinationpoints = response.data;
  //       this.dpReady = true;
  //       this.componentKey += 1;
  //     });
  //     console.log(res);
  //     return res.data;
  //   }
  // },
    computed: {
      reading() { return this.filters.post }
    },
    mounted() {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BlogFooter.vue